import { ApiService } from 'src/common/api-service/API-BETTING'

export default {
  namespace: true,
  state: () => ({
    history: {
      bet_list: [],
    },
    sports: null,
    liveSports: [],
    videoEventsIds: null,
    basket: {},
    favorites: [],
    snackbarMessage: '',
    sideRightMenuIsExpand: false,
    liveMatchTrackerShow: false,
    liveMatchTrackerBroadcastId: null,
    activePromoChip: 'all',
    selectedPromoFilters: [],
    fastbetSum: 100,
    betsAccepted: false,
    fastbetOnProgress: false,
    historyTimeShift: null,
  }),
  mutations: {
    UPDATE_HISTORY(state, payload) {
      state.history = payload
    },
    UPDATE_SPORTS(state, payload) {
      state.sports = payload
    },
    UPDATE_LIVE_SPORTS(state, payload) {
      state.liveSports = payload
    },
    updateVideoEventsIds(state, payload) {
      state.videoEventsIds = payload
    },
    UPDATE_BASKET(state, payload) {
      state.basket = payload
    },
    UPDATE_FAVORITES(state, payload) {
      state.favorites = payload
    },
    UPDATE_SIDE_RIGHT_MENU_EXPANDED(state, payload) {
      state.sideRightMenuIsExpand = payload
    },
    UPDATE_LIVE_MATCH_TRACKER_SHOW(state, payload) {
      state.liveMatchTrackerShow = payload
    },
    UPDATE_LIVE_MATCH_TRACKER_BROADCAST_ID(state, payload) {
      state.liveMatchTrackerBroadcastId = payload
    },
    UPDATE_SNACKBAR_MESSAGE(state, payload) {
      state.snackbarMessage = payload
    },
    UPDATE_ACTIVE_PROMO_CHIP(state, payload) {
      state.activePromoChip = payload
    },
    UPDATE_SELECTED_PROMO_FILTERS(state, payload) {
      state.selectedPromoFilters = payload
    },
    UPDATE_FASTBET_SUM(state, value) {
      state.fastbetSum = value
    },
    UPDATE_BETS_ACCEPTED(state, value) {
      state.betsAccepted = value
    },
    UPDATE_FASTBET_ON_PROGRESS(state, value) {
      state.fastbetOnProgress = value
    },
    UPDATE_HISTORY_TIME_SHIFT(state, payload) {
      state.historyTimeShift = payload
    },
  },
  actions: {
    async fetchHistory({ commit }, { date, time_shift, filter, offset }) {
      await ApiService.history({ date, time_shift, filter, limit: 10, offset })
        .then(({ data }) => {
          commit('UPDATE_HISTORY', data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async fetchSports({ commit }, payload) {
      const { data } = await ApiService.slice({ live: '1', ...payload })

      const sports = data.reduce((aggregatedData, sport) => {
        const tournament = { id: sport.id, name: sport.cn }
        const events = sport.it.map((event) => ({ ...event, tournament }))
        if (aggregatedData[sport.so]) {
          aggregatedData[sport.so].events.push(...events)
          aggregatedData[sport.so].tournaments.push(tournament)
        } else {
          aggregatedData[sport.so] = {
            id: sport.sport_id,
            name: sport.sn,
            order: sport.so,
            events,
            tournaments: [tournament],
          }
        }
        return aggregatedData
      }, {})
      commit('UPDATE_LIVE_SPORTS', sports)
    },
    async basketAdd({ commit }, { coefs_ids, sport_id }) {
      try {
        const { data } = await ApiService.basketAdd({ coefs_ids, sport_id })
        commit('UPDATE_BASKET', data)
        return data
      } catch (error) {
        console.log(error)
        return error
      }
    },
    async basketDelete({ commit }, { coefs_ids }) {
      try {
        const { data } = await ApiService.basketDelete({ coefs_ids })
        commit('UPDATE_BASKET', data)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchBasket({ commit }) {
      try {
        const { data } = await ApiService.basketList()
        commit('UPDATE_BASKET', data)
      } catch (error) {
        console.log(error)
      }
    },
    basketClear({ commit }) {
      ApiService.basketClear()
        .then(({ data }) => {
          commit('UPDATE_BASKET', data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async basketSave({}, { sum, bet_type, save_any, any_handicap, bonus, system_type }) {
      try {
        await ApiService.basketSave({ sum, bet_type, save_any, any_handicap, bonus, system_type })
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async basketFast({}, { sum, sport_id, save_any, any_handicap, coefs_ids, fast = '1' }) {
      try {
        await ApiService.basketFast({ sum, sport_id, save_any, any_handicap, coefs_ids, fast })
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async fetchFavorites({ commit }) {
      await ApiService.favoritesList()
        .then(({ data }) => {
          commit('UPDATE_FAVORITES', data)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async addFavorite(ctx, event) {
      ApiService.favorites({
        action: 'add',
        sport_id: event.sport_id || event.sid,
        match_id: event.id,
      })
        .then(() => {
          ctx.dispatch('fetchFavorites')
        })
        .catch((e) => {
          console.error(e)
        })
    },
    async deleteFavorite(ctx, event) {
      ApiService.favorites({
        action: 'remove',
        sport_id: event.sport_id || event.sid,
        match_id: event.id,
      })
        .then(() => {
          ctx.dispatch('fetchFavorites')
        })
        .catch((e) => {
          console.error(e)
        })
    },
    async deleteAllFavorites({ commit }) {
      await ApiService.favorites({ action: 'clearAll' })
        .then(() => {
          commit('UPDATE_FAVORITES', [])
        })
        .catch((error) => {
          console.log(error)
        })
    },
    openLiveMatchTracker(ctx, liveMatchTrackerBroadcastId) {
      ctx.commit('UPDATE_LIVE_MATCH_TRACKER_BROADCAST_ID', liveMatchTrackerBroadcastId)
      ctx.commit('UPDATE_LIVE_MATCH_TRACKER_SHOW', true)
    },
  },
  getters: {
    getHistory: (state) => {
      return {
        ...state.history,
        bet_list: state.history?.bet_list.map((bet) => {
          return {
            ...bet,
            events: bet?.events.map((event) => {
              return {
                ...event,
                score: 0,
              }
            }),
          }
        }),
      }
    },
    liveSports: (state) => Object.values(state.liveSports) || [],
    getVideoStatus: (state) => (id) => state.videoEventsIds?.[id] ?? null,
    getBasket: (state) => state.basket ?? null,
    favoritesList: (state) => state.favorites,
    favorites: (state) => {
      const result = []
      const categories = [...new Set(state.favorites?.map((event) => event.status))]

      categories.forEach((category) => {
        if (category !== 'RESULTS') {
          const events = state.favorites
            .filter((event) => event.status === category)
            .map(({ ...eventData }) => eventData)

          result.push({ category, events })
        }
      })

      return result.sort((a, b) => (b.category > a.category ? 1 : -1))
    },
    getSnackbarMessage: (state) => state.snackbarMessage,
    getSideRightMenuIsExpand: (state) => state.sideRightMenuIsExpand,
    getLiveMatchTrackerBroadcastId: (state) => state.liveMatchTrackerBroadcastId,
    getLiveMatchTrackerShow: (state) => state.liveMatchTrackerShow,
    getActivePromoChip: (state) => state.activePromoChip,
    getSelectedPromoFilters: (state) => state.selectedPromoFilters,
    getFastbetSum: (state) => state.fastbetSum,
    getBetsAccepted: (state) => state.betsAccepted,
    getFastbetOnProgress: (state) => state.fastbetOnProgress,
    getHistoryTimeShift: (state) => state.historyTimeShift,
  },
}
